import { render, staticRenderFns } from "./supper.vue?vue&type=template&id=5a4c46f0&"
import script from "./supper.vue?vue&type=script&lang=js&"
export * from "./supper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports